import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.import-csv.import-completed', {
        url: '/completed',
        params: {importResult: null},
		views: {
            '@company.sharing-center': 'companySharingCenterImportCompleted'
        }
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.state.js